const agentInfo = {
    state: {
        name: '', //代理商的名称
        wechat: '', //微信
        logoUrl: '', //logo图片地址
        email: '', //邮箱地址
        phone: '', //手机
        qq: '', //qq号
        websiteUrl: '', // 代理商网址
        address: '', //代理商地址
        distSpId:'', //代理商编号
        authority:'', //备案信息
    },
    mutations: {
        //登陆成功后标记
        SET_AGENT_INFO(state, fullAgentInfo) {
            state.name = fullAgentInfo.name;
            state.logoUrl = fullAgentInfo.logoUrl;
            state.wechat = fullAgentInfo.wechat;
            state.email = fullAgentInfo.email;
            state.phone = fullAgentInfo.phone;
            state.websiteUrl = fullAgentInfo.websiteUrl;
            state.qq = fullAgentInfo.qq;
            state.address = fullAgentInfo.address;
            state.distSpId = fullAgentInfo.distSpId;
            state.authority = fullAgentInfo.authority;
        }
    },
    actions: {
        setAgentInfo({ commit }, fullAgentInfo) {
            commit('SET_AGENT_INFO', fullAgentInfo)
        }
    }
}

export default agentInfo


// WEBPACK FOOTER //
// ./src/store/modules/agentInfo.js